/**
 * Formats the lender and program name display
 * @param lenderLegalName - The legal name of the lender
 * @param programName - The name of the financing program
 * @param fallback - Optional fallback text when both are missing (default: empty string)
 * @returns Formatted string: "Lender - Program", or just one of them if the other is missing, or fallback
 */
export const formatLenderProgramDisplay = (lenderLegalName?: string, programName?: string, fallback: string = ''): string => {
    if (lenderLegalName && programName) {
        return `${lenderLegalName} - ${programName}`;
    }
    return programName || lenderLegalName || fallback;
};
